import JobPostRoutes from './JobPostRoutes';
export { basePath, routesConfig } from './JobPostRoutes';
export default JobPostRoutes;